// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202609111204/js/" + chunkId + "." + {"44":"f30cc594","225":"769a3bba","481":"03f48ea2","486":"36d311ea","770":"81cd62a1"}[chunkId] + ".0.8944137123332258.chunk.js";
};